// --------------------------------------------------------------------------------------------------------------------
// Simple Carousel-component - inspired by Nuka-carousel
// --------------------------------------------------------------------------------------------------------------------
'use strict';

import React, { Component, PropTypes } from 'react';
import defaultDecoratorPkg from './defaultDecorator';

import css from './carousel.scss';

export const DIRECTION_HORIZONTAL = 'DIRECTION_HORIZONTAL';
export const DIRECTION_VERTICAL = 'DIRECTION_VERTICAL';

export default class Carousel extends Component {
	static propTypes = {};
	static defaultProps = {
		decorators: [defaultDecoratorPkg],
		decoratorData: {},
		timer: 4000,
		startingSlide: 0,
		direction: DIRECTION_HORIZONTAL,
		autoPlayVid: false,
	};

	constructor(props) {
		super(props);

		this.mounted = true;

		const skipSlides = [];
		React.Children.map(props.children, (child, index) => {
			if (child.props.skipSlide) {
				skipSlides.push(index);
			}
		});

		this.state = {
			prevSlide: props.startingSlide,
			currentSlide: props.startingSlide,
			slideCount: 0,
			direction: this.props.direction,
			autoplay: this.props.autoplay,
			playVideo: false,
			skipSlides,
		};
	}

	componentWillMount() {
		this.setState({
			...this.state,
			slideCount: React.Children.count(this.props.children),
			slideClasses: React.Children.map(this.props.children, (child) => {
				let classes = '';
				if (child.props && typeof child.props.codaClass === 'string') {
					classes += ' ' + child.props.codaClass;
				}

				return classes;
			}),
		});
	}

	shouldComponentUpdate(nextProps, nextState) {
		return !!(
			(nextProps.children !== this.props.children) ||
			(nextProps.autoPlayVid !== this.props.autoPlayVid) ||
			(nextState.playVideo !== this.state.playVideo) ||
			(nextState.currentSlide !== this.state.currentSlide) ||
			this.props.autoplay
		);
	}

	componentWillReceiveProps(nextProps) {
		const skipSlides = [];
		React.Children.map(nextProps.children, (child, index) => {
			if (child.props.skipSlide) {
				skipSlides.push(index);
			}
		});

		this.setState({
			...this.state,
			slideCount: React.Children.count(nextProps.children),
			currentSlide: this.state.currentSlide % (React.Children.count(nextProps.children) || 1),
			autoplay: nextProps.autoplay,
			skipSlides,
		});
	}

	componentDidUpdate() {
		if (this.state.playVideo && this.props.autoPlayVid) {
			this.props.autoPlayVid.playVideo();
			this.state.playVideo = false;
		}
	}

	componentWillUnmount() {
		this.mounted = false;
		clearTimeout(this.timer);
	}

	render() {
		var _this = this;
		var children = this.formatChildren(this.props.children);
		let sliderClass = 'slider';
		let sliderListClass = 'slider-list';
		let decoClass = '';

		if (this.props.sliderClass) {
			sliderClass += ' ' + this.props.sliderClass;
		}

		if (this.props.sliderListClass) {
			sliderListClass += ' ' + this.props.sliderListClass;
		}

		if (this.props.decoClass) {
			decoClass += ' ' + this.props.decoClass;
		}

		if (this.props.autoplay && this.state.autoplay) {
			this.timer && clearTimeout(this.timer);
			this.timer = setTimeout(() => {
				this.nextSlide();
			}, this.props.timer);
		}

		if (!this.state.autoplay) {
			this.timer && clearTimeout(this.timer);
		}

		return (
			<div className={sliderClass} data-slide={this.state.currentSlide}>
				<ul className={sliderListClass} onTouchStart={(e) => this.onTouchStart(e)} onTouchMove={(e) => this.onTouchMove(e)} onTouchEnd={(e) => this.onTouchEnd(e)}>
					{children}
				</ul>
				{this.state.slideCount > 1 && this.props.decorators ?
					this.props.decorators.map((Decorator, index) => {
						let DecoComponent = Decorator.component;
						if (!DecoComponent) {
							return false;
						}

						return (
							<div
								style={Decorator.style || {}}
								className={'slider-decorator-' + index + decoClass}
								key={index}>
								<DecoComponent
									{...this.state}
									decoratorData={this.props.decoratorData}
									nextSlide={() => { this.nextSlide(); }}
									onVideoPlay={() => {_this.setState({..._this.state, playVideo: true}); }}
									hasVideo={_this.props.hasVideo}
									previousSlide={() => { this.previousSlide(); }}
									goToSlide={(slideNumber, disableAutoplay = false) => { this.goToSlide(slideNumber, disableAutoplay); }} />
							</div>
						);
					})
				: null}
			</div>
		);
	}

	formatChildren(children) {
		var _this = this;
		return React.Children.map(children, function(child, index) {
			var className = 'slider-slide';
			if (_this.state.currentSlide === index) {
				className += ' slider-slide--active';
			}

			if (_this.state.prevSlide === index) {
				className += ' slider-slide--prev';
			}

			return (<li className={className} style={{}} key={index}>{child}</li>);
		});
	}

	nextSlide(disableAutoplay = false, skip = 0) {
		const nextSlide = (this.state.currentSlide + 1 + skip) % (this.state.slideCount);
		// if (this.state.skipSlides.indexOf(nextSlide) !== -1) {
		// 	return this.nextSlide(disableAutoplay, skip + 1);
		// }

		return this.goToSlide(nextSlide, disableAutoplay);
	}

	previousSlide(disableAutoplay = false) {
		this.goToSlide(this.state.currentSlide - 1, disableAutoplay);
	}

	goToSlide(slideNumber = false, disableAutoplay = false) {
		if (typeof slideNumber !== 'number') {
			return;
		}

		// Make sure currentSlide is within bounds
		slideNumber = Math.max(Math.min(slideNumber, this.state.slideCount - 1), 0);

		setTimeout(() => {
			this.mounted && this.setState({
				...this.state,
				autoplay: this.props.autoplay,
			});
		}, 10000);

		this.setState({
			...this.state,
			swiping: false,
			prevSlide: this.state.currentSlide,
			currentSlide: slideNumber,
			autoplay: !disableAutoplay,
		});
	}

	calculatePos(e) {
		let x = e.changedTouches[0].clientX;
		let y = e.changedTouches[0].clientY;

		let xd = this.state.x - x;
		let yd = this.state.y - y;

		let axd = Math.abs(xd);
		let ayd = Math.abs(yd);

		return {
			deltaX: xd,
			deltaY: yd,
			absX: axd,
			absY: ayd,
		};
	}

	onTouchStart(ev) {
		// console.log('onTouchStart: ', ev);
		if (ev.touches.length > 1) {
			return;
		}

		this.setState({
			...this.state,
			swipeStart: Date.now(),
			x: ev.touches[0].clientX,
			y: ev.touches[0].clientY,
			swiping: true,
		});
	}

	onTouchMove(ev) {
		// console.log('onTouchMove: ', e);
	}

	onTouchEnd(ev) {
		// console.log('onTouchEnd: ');
		if (this.state.swiping) {
			var pos = this.calculatePos(ev);

			// var time = Date.now() - this.state.swipeStart;
			// var velocity = Math.sqrt(pos.absX * pos.absX + pos.absY * pos.absY) / time;
			// var isFlick = velocity > this.props.flickThreshold;

			// this.props.onSwiped && this.props.onSwiped(
			// 	ev,
			// 	pos.deltaX,
			// 	pos.deltaY,
			// 	isFlick,
			// );

			if (pos.absX > pos.absY) {
				if (this.state.direction === DIRECTION_HORIZONTAL) {
					if (pos.deltaX > 0) {
						// LEFT
						//console.log('swipe-NEXT');
						return this.nextSlide();
					} else {
						// RIGHT
						//console.log('swipe-PREV');
						return this.previousSlide();
					}
				}
			} else {
				if (this.state.direction === DIRECTION_VERTICAL) {
					if (pos.deltaY > 0) {
						// UP
						//console.log('swipe-NEXT');
						return this.nextSlide();
					} else {
						// DOWN
						//console.log('swipe-PREV');
						return this.previousSlide();
					}
				}
			}
		}

		this.setState({
			...this.state,
			swiping: false,
		});
	}
}



/** WEBPACK FOOTER **
 ** ./frontend/components/carousel/carousel.js
 **/